import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Textarea,
  Text,
} from "@chakra-ui/react";

/**
 * Shared Approve / Reject modal.
 * Used by both SourceSection.jsx and OutputSection.jsx.
 *
 * Props:
 * - isOpen, onClose
 * - itemName: label shown in header (file name / source name)
 * - loading: disables buttons while API call is in-flight
 * - onSubmit(status, comment) -> status is "approved" | "declined"
 */
const ApprovalModal = ({ isOpen, onClose, itemName, loading, onSubmit }) => {
  const [comment, setComment] = useState("");

  useEffect(() => {
    if (isOpen) {
      setComment("");
    }
  }, [isOpen]);

  const handleAction = (status) => {
    onSubmit(status, comment.trim());
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Review Submission</ModalHeader>
        <ModalCloseButton isDisabled={loading} />
        <ModalBody>
          {itemName ? (
            <Text fontSize="sm" color="gray.600" mb={4} noOfLines={1}>
              {itemName}
            </Text>
          ) : null}
          <FormControl>
            <FormLabel fontSize="sm" fontWeight="600" color="gray.700">
              Comment (optional)
            </FormLabel>
            <Textarea
              placeholder="Enter comment"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              isDisabled={loading}
            />
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button
            variant="outline"
            mr={3}
            onClick={onClose}
            isDisabled={loading}
          >
            Cancel
          </Button>
          <Button
            colorScheme="red"
            mr={3}
            onClick={() => handleAction("declined")}
            isLoading={loading}
            loadingText="Rejecting..."
          >
            Reject
          </Button>
          <Button
            colorScheme="green"
            onClick={() => handleAction("approved")}
            isLoading={loading}
            loadingText="Approving..."
          >
            Approve
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ApprovalModal;